import { VALUES_GET_LIST,VALUES_GET_LIST_SUCCESS,VALUES_GET_LIST_ERROR } from "../../../redux/contants";

const INIT_STATE = {
    getValuesList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case VALUES_GET_LIST:
            // alert(action.type)
            // alert(action.data)
            return { ...state, loading: true, error: '' };
        case VALUES_GET_LIST_SUCCESS:
            console.log('VALUES_GET_LIST_SUCCESS===',action);
            return {
                ...state,
                loading: false,
                getValuesList: action.data,
                error: '',
                messages: ''
            };
        case VALUES_GET_LIST_ERROR:
            return {
                ...state,
                loading: false,
                getValuesList: [],
                error: action.error,
                messages: ''
            };
        default:
            return { ...state };
    }
};
